<div class="container-fluid mt-3">
    <div class="card">
        <div class="card-header"><strong>{{ 'kobeac.report_management' | transloco }}</strong></div>
        <div class="card-body">
            <div class="row mb-2">
                <div class="col-md-2">
                    <select class="form-control" [(ngModel)]="reportClass" (change)="onLineChange()">
                        <option *ngFor="let l of lines" [value]="l.key">{{ l.labelKey | transloco }}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <select class="form-control" [(ngModel)]="selected">
                        <option *ngFor="let t of templates" [value]="t.name">{{ t.name }}</option>
                    </select>
                </div>
                <div class="col-md-1"><button (click)="refresh()" class="btn btn-block btn-success">{{ 'common.select' | transloco }}</button></div>
                <div class="col-md-3">
                    <input type="text" class="form-control" [(ngModel)]="selected" [placeholder]="'kobeac.report_name' | transloco">
                </div>
                <div class="col-md-2"><button [disabled]="!selected" (click)="saveReport()" class="btn btn-block btn-success">{{ 'kobeac.save_report' | transloco }}</button></div>
            </div>
            <div class="row">
                <div id="designerContent" style="width:100%"></div>
                <div id="viewerContent" style="width:100%;min-height:600px"></div>
            </div>
        </div>
    </div>
</div>
